<template>
  <div class="relative right-0 h-full flex">
    <iframe 
      src="https://itch.io/embed-upload/14838421?color=333333" 
      allowfullscreen="" 
      width="1280" 
      height="740" 
      frameborder="0"
      class="w-full h-full"
    >
      Play Maze Escape on itch.io
    </iframe>
  </div>
</template>

<script setup>
// No special logic needed for iframe embedding
</script>
